export class VehicleFile {
    constructor
        (
            public title: string,
            public url: string
        ) { }
}
